module.exports = __webpack_public_path__ + "media/images/floor_plan/chair_1-8aa8c8eadec393d2ed574534829c1444.png";